import { api } from './api.js';

// Turning the builder's swap 409 into a one-click action.
//
// CJ 2026-08-23: "Avery and Abigail tried but couldn't do it for the same day.
// Gina manually switched it." Reassigning shift A to somebody who already works
// that day collides with their own shift, so swapping two people one edit at a
// time is impossible by construction — the manager's only route was unassign,
// reassign, reassign, with a shift sitting uncovered in the middle.
//
// The server now answers that collision with `swap_with_shift_id` naming the
// other shift, and POST /api/shifts/swap-assignees exchanges both assignees in
// one transaction. This is the piece that connects them: the message that says
// "Swap the two shifts instead" becomes a button that does it.
//
// Owns the whole failed-save path: it reports the error (this is the alert the
// caller used to raise itself) and returns true only when a swap actually ran,
// so the caller's sole job is to reload.
export async function offerSwapOnConflict(rawError, shiftId, headers) {
  let message = rawError || 'Save failed';
  let payload = null;
  try { payload = JSON.parse(message); } catch { /* plain-text error */ }
  if (payload) {
    message = payload.error + (payload.details ? ': ' + payload.details.join(', ') : '');
  }

  const other = payload?.swap_with_shift_id;
  // Only the collision the server marked swappable. Every other 409 — a real
  // overlap with the SAME person's other shift, time off, an unauthorised
  // café — must still refuse, and must not be described as a swap.
  if (!other || !shiftId) { alert(message); return false; }

  // Declining is not an error, so it says nothing further.
  if (!confirm(`${message}\n\nSwap the two shifts now? They trade places — both change at the same moment.`)) return false;

  try {
    await api('POST', '/api/shifts/swap-assignees', { a: shiftId, b: other }, headers);
    return true;
  } catch (e) {
    let m = e.message || 'Swap failed';
    try { const p = JSON.parse(m); m = p.error || m; } catch { /* plain-text error */ }
    alert(`Swap failed: ${m}`);
    return false;
  }
}
